<template>
<span :class="`odr-message odr-message_color-${color}`">
    <tpl :content="title"/>
</span>
</template>

<script>
import '@/scss/blocks/message.scss';
import { coloringMixin } from '@clearwave/odoro-markup/lib/mixins/coloring';

export default {
    mixins: [coloringMixin],
    props: {
        title: {},
    },
    components: {
        tpl: require('@/vue/markup/tpl.vue').default,
    },
};
</script>
